import { Button } from "@/components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const InviteTeam = ({ children, team }: { children: React.ReactNode, team: any }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [inviteError, setInviteError] = useState('');
    const [inviteUrl, setInviteUrl] = useState('');
    const [applicationEnabled, setApplicationEnabled] = useState(true);
    const streamerMode = JSON.parse(localStorage.getItem("streamerMode")!);
    const createInviteUrl = async (team: String, applicationEnabled: Boolean) => {
        const res = await fetch("__SITE_BASE__/api/v1/teams/invite", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ teamId: team, applicationEnabled, type: "team" }),
        });
        const data = await res.json();
        if(!data.success) {setInviteUrl('');return setInviteError(data.message);}
        setInviteUrl(window.location.origin + '/invite/' + data.invite);
        setInviteError('');
    }

    useEffect(() => {
        if(!isOpen) return;
        createInviteUrl(team, applicationEnabled);
    }, [team, applicationEnabled, isOpen]);

    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogTrigger>
                {children}
            </DialogTrigger>
            <DialogContent className="bg-brand-dark text-white border-0 rounded-lg">
                <DialogHeader className="items-center justify-center">
                    <DialogTitle>
                        Invite to Team
                    </DialogTitle>
                </DialogHeader>
                <div className="flex flex-col gap-4 items-center justify-center p-4">
                    <div className="flex flex-col w-full justify-center gap-4">
                        <Label className="text-white">Invite URL</Label>
                        {inviteError && <div className="text-red-500 text-sm">{inviteError}</div>}
                        <div className="flex items-center justify-center w-full">
                            <Input
                                value={streamerMode?.enabled && streamerMode?.details?.hideInviteLinks ? '[Streamer Mode]' : inviteUrl}
                                readOnly
                                className="rounded-t-lg rounded-l-lg bg-brand-darkest border-r-0 border-l-0 border-t-0 border-b-brand-green placeholder:text-gray-300 w-full"
                            />
                            <Button
                                onClick={() => { navigator.clipboard.writeText(inviteUrl) }}
                                className="rounded-r-lg bg-brand-green text-white hover:bg-brand-green"
                            >
                                Copy
                            </Button>
                        </div>
                    </div>

                    <div className="flex flex-col w-full items-center justify-center gap-4">
                        <div className="flex items-center justify-between w-full">
                            <div className="flex flex-col items-start">
                                <Label className="text-white">Application Enabled</Label>
                                <p className="text-gray-500 text-sm">
                                    Users will have to fill out an application to join the team
                                </p>
                            </div>
                            <div
                                className={`relative inline-flex items-center cursor-pointer`}
                                onClick={() => setApplicationEnabled(!applicationEnabled)}
                            >
                                <input
                                    type="checkbox"
                                    className="sr-only"
                                    checked={applicationEnabled}
                                    onChange={() => setApplicationEnabled(!applicationEnabled)}
                                />
                                <div
                                    className={`block w-14 h-8 rounded-full ${
                                        applicationEnabled ? 'bg-brand-green' : 'bg-brand-profile'
                                    }`}
                                >
                                    <div
                                        className={`absolute left-1 top-1 bg-white w-6 h-6 rounded-full transition-transform ${
                                            applicationEnabled ? 'translate-x-6' : 'translate-x-0'
                                        }`}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};
